// ----- Base
import "../../../../js/base";
import "../../../../js/atoms/toggle/translate-contents";
import "../../../../js/molecules/course-navigation/course-navigation-new";
import "../../../../js/molecules/popover/teacher-popover";
import "../../../../js/molecules/countdown/countdown";
import "../../../../js/molecules/popover/sharing-buttons-popover";
import "../../../../js/molecules/promo-header/promo-header-new";
import "../../../../js/organism/sidebar/sidebarCourse";
import "../../../../js/organism/shareButton/events";
import "../../../../js/molecules/popover/events";
import "../../../../js/molecules/fields/copyToClipboardField";
import "../../../../js/atoms/modals/modals";

Domestika.courses_controller.show_new();
